module.exports = __webpack_public_path__ + "resources/img/bg_cover_support_v2.2a780e6fecba2d623cffbdf270445f6e.png";